export const SCORE_TABLE_OBJ = {
  assetLiabilityRatio: {
    label: '总资产负债率（%）',
    financialRatio: 'Y',
  },
  netWorth: {
    label: '净资产（元）',
    financialRatio: 'Y',
    filter: 'formatAmount',
  },
  operatingFunds: {
    label: '营运资金（元）',
    financialRatio: 'Y',
    filter: 'formatAmount',
  },
  retainedEarnings: {
    label: '留存收益/总资产（%）',
    financialRatio: 'Y',
  },
  currentLiabilities: {
    label: '流动负债/净资产（%）',
    financialRatio: 'Y',
  },
  quickFrozenRatio: {
    label: '速动比率（%）',
    financialRatio: 'Y',
  },
  netProfitRatio: {
    label: '净利润率（%）',
    financialRatio: 'Y',
  },
  operatingIncome: {
    label: '主营业务收入/总资产（%）',
    financialRatio: 'Y',
  },
  netWorthProfitRatio: {
    label: '净资产收益率（%）',
    financialRatio: 'Y',
  },
  accountsReceiveDays: {
    label: '应收账款周转天数（日',
    financialRatio: 'Y',
  },
  accountsPayDays: {
    label: '应付账款周转天数（日）',
    financialRatio: 'Y',
  },
  inventoryTurnoverDays: {
    label: '库存周转天数（日）',
    financialRatio: 'Y',
  },
  salesGrowthRate: {
    label: '销售增长率（%）',
    financialRatio: 'Y',
  },
  lastRefundAvgDays: {
    label: '上一财年加权平均回款天数（日）',
    financialRatio: 'N',
  },
  lastExpiryRate: {
    label: '上一财年3天以上逾期率（%）',
    financialRatio: 'N',
  },
  expiryAvgDays: {
    label: '近三财年加权平均逾期天数（日）',
    financialRatio: 'N',
  },
  expiryAvgRate: {
    label: '近三财年3天以上逾期率（%）',
    financialRatio: 'N',
  },
  isExpiryRisk: {
    label: '上一财年是否出现真实逾期风险：是/否/新客户（-10/10/0）',
    financialRatio: 'N',
    filter: 'confirmStatus',
  },
  isExpiry: {
    label: '目前是否存在真实逾期：是/否/新客户（-10/10/0',
    financialRatio: 'N',
    filter: 'confirmStatus',
  },
  purchase: {
    label: '近三年进货额（元）',
    financialRatio: 'N',
    filter: 'formatAmount',
  },
  purchasePlan: {
    label: '未来一年联想直接采购预估额（元）',
    financialRatio: 'N',
    filter: 'formatAmount',
  },
  purchaseRateIncrement: {
    label: '联想业务直接采购额年增长率（%',
    financialRatio: 'N',
  },
  industryLevel: {
    label: '行业风险级别',
    financialRatio: 'N',
  },
  regionLevel: {
    label: '地域风险级别',
    financialRatio: 'N',
  },
  establishYear: {
    label: '成立年限',
    financialRatio: 'N',
  },
  coopTime: {
    label: '合作年限',
    financialRatio: 'N',
  },
  actualReceipt: {
    label: '实收资本（元）',
    financialRatio: 'N',
    filter: 'formatAmount',
  },
  shareholderNature: {
    label: '股东性质',
    financialRatio: 'N',
    filter: 'companyProperty',
  },
  subjectiveEvaluation: {
    label: '主观评价',
    financialRatio: 'N',
  },
}

export const CONFIRM_STATUS_OBJ = {
  1: '是',
  2: '否',
  3: '新客户',
}

export const COMPANY_PROPERTY_OBJ = {
  1: '上市公司',
  2: '央企、国企',
  3: '股份有限公司',
  4: '有限责任公司',
  5: '其他（私人等）',
}
